
define('events',['jquery', 'backbone', 'backbone.marionette', 'backbone.wreqr'],
    function ($, backbone, Marionette, Wreqr) {
        'use strict';
        
        return Wreqr.radio.channel('global').vent;
    });